module.exports = __webpack_public_path__ + "media/src/fonts/uni-neue/uni-neue-100-thin-italic-62a957b7e3097728b2713f4ffe3deb64.woff2";